export const colors = {
  accent: '#081f65',//081f65
  accentLight: '#cbe5f5',
  accentLighter: '#e7f3fb',
  background: '#ffffff',
  backgroundAlt: '#eeeeee',
  text: '#333333',
  textOnAccent: '#fff',
  textAccent: '#0d7abf',
  textDark: '#ddd',
  buttonBackground: '#ef5f47'
};

export const layout = {
  maxWidth: '1140px',
  breakpoints: {
    mobile: '800px',
    tablet: '1140px'
  }
};

export const brands = {
  ABCBS: 'Anthem BCBS',
  ABC: 'Anthem BC',
  EBCBS: 'Empire BCBS',
  EBC: 'Empire BC',
  BCNY:'Anthem BC NY',
  BCBSNY:'Anthem BCBS NY'
};


 